var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLayerIcon = function SvgLayerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.9124 8L8.00033 12.8371L2.08826 8L8.00033 3.16285L13.9124 8Z",
    stroke: "#767676",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  }))));
};
export { SvgLayerIcon as ReactComponent };
export default __webpack_public_path__ + "assets/1cf7e5de.svg";